(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "d0fca1e8a019b10ea04c0d1ab0e59a81417c48ee"
};